<script>
    import CheckBox from 'southcn-ui2/src/components/widgets/CheckBox';
    import NormalLabel from 'southcn-ui2/src/components/widgets/NormalLabel';

    import md5 from 'md5';
    import moment from 'moment';

    export default {
        name: 'login-box',
        props: {
            hideRegister: {
                type: Boolean,
                required: false,
                default: false,
            },
        },
        data () {
            return {
                codeImageUrl: '',
                codeType: 'wx',
                btnText: '获取验证码',
                redirectUri: '',
                error_type: null,
                csrf_token: window.laravel._CSRF,
                wayFlag: true,
                checkPwd: false,
                loading: false,
                loginUser: {
                    email: '',
                    password: '',
                    code: '',
                    app: '',
                    phone: '',
                    captcha: '',
                },
                formUrl: '',
                pwd: '',
                code: '',
                captchaImg: '',
                smsImgCaptchaImg: '',
                initedHeight: '',
                oauthAppInfo: '',
                appId: '',
                state: '',
                platformText: `“${ window.__APP__CONFIG.pt_name }”`,
                panelText: '微信两步验证',
                lastText: '短信两步验证',
                wayType: 'wechat',
                scanCodeText: '请使用微信扫描二维码验证',
                sceneVerifyTimer: null,
                token: '',
                imgCode: '',
                showTipsBeforeScan: this.$storage(false).getItem('punch_in_label') || false
            };
        },
        methods: {
            selectWay (flag) {
                clearInterval(this.sceneVerifyTimer);
                this.wayFlag = flag;
                this.computeHeight();
                this.refreshCaptcha();
            },
            computeHeight () {
                setTimeout(() => {
                    this.initedHeight = `${
                        this.$refs.loginForm.getBoundingClientRect().height
                    }px`;
                });
            },
            rememberPwd (val) {
                this.checkPwd = val;
            },
            initLoginUser () {
                let loginUser = this.$storage(true).getItem('loginUser');
                if (loginUser) {
                    this.loginUser = loginUser;
                    this.pwd = loginUser.password;
                    this.checkPwd = true;
                }
            },
            check () {
                if (!this.loginUser.email) {
                    this.$modal.alert({
                        text: '请输入登录邮箱。',
                        okCallback: () => {
                            this.$refs.email.focus();
                        },
                    });
                    return true;
                }
                this.loginUser.email = this.loginUser.email.trim();
                if (!this.$util.validate.email(this.loginUser.email)) {
                    this.$modal.alert({
                        text: '请输入正确格式的邮箱地址。',
                        okCallback: () => {
                            this.$refs.email.focus();
                        },
                    });
                    return true;
                }
                if (!this.pwd) {
                    this.$modal.alert({
                        text: '请输入登录密码。',
                        okCallback: () => {
                            this.$refs.pwd.focus();
                        },
                    });
                    return true;
                }
                if (!this.code) {
                    this.$modal.alert({
                        text: '请输入验证码。',
                        okCallback: () => {
                            this.$refs.captcha.focus();
                        },
                    });
                    return true;
                }
                this.code = this.code.trim();
                return false;
            },
            async login () {
                if (this.check() || this.loading) {
                    return;
                }
                this.loading = true;
                this.$refs.captcha.blur();
                this.$refs.pwd.blur();
                this.$refs.email.blur();
                this.loginUser.password = this.pwd;
                this.loginUser.code = this.code;
                this.loginUser.app = this.$route.query.appid || '';
                this.$storage(true).removeItem('targetEmail');
                if (this.checkPwd) {
                    this.$storage(true).setItem('loginUser', this.loginUser);
                } else {
                    this.$storage(true).removeItem('loginUser');
                }
                this.loginUser.password = md5(this.pwd);
                try {
                    const result = await this.$api(
                        this.$config.apiUrl.checkLogin,
                        this.loginUser
                    );
                    // this.wayFlag = false;
                    this.formUrl = this.$config.apiUrl.formLogin;
                    this.platformText = `“${ window.__APP__CONFIG.pt_name }”`;
                    this.$storage(true).removeItem('expired-tips');
                    this.showTipsBeforeScan = result.punch_in_label;
                    this.$storage(false).setItem('punch_in_label', this.showTipsBeforeScan);
                    if (result.skip) {
                        this.$storage(true).removeItem('currentSite');
                        this.$nextTick(() => {
                            this.$refs.loginForm.submit();
                        });
                        return;
                    } else if (result.wx) {
                        this.panelText = '微信两步验证';
                        this.scanCodeText = '请使用微信扫描二维码验证';
                    } else {
                        this.scanCodeText = '请使用微信扫描二维码绑定';
                        this.panelText = '您还未绑定微信，为了您的账号安全，请扫码绑定';
                    }
                    this.codeType = 'wx';
                    /**
                     * wx_oauth为3时使用混用模式
                     * 这里原逻辑为混用模式时调用服务号的二维码,否则调用网站应用的二维码。
                     * 现需求为混用模式下，未绑定时使用服务号二维码，否则使用网站应用二维码
                     * result.wx表示有无绑定微信
                     */
                    //3.10oldCode
                    // if (this.$store.state.appUrls.wx_oauth === '3') {
                    //     this.scanCodeText = '请使用微信扫描二维码验证';
                    //     this.codeType = 'server';
                    //     this.getWxImage(result.wx);
                    // }
                    // if (this.codeType === 'wx') {
                    //     this.initWxLogin();
                    // }
                    //3.10newCode
                    if (this.$store.state.appUrls.wx_oauth === '3' && !result.wx) {
                        this.scanCodeText = '请使用微信扫描二维码验证';
                        this.codeType = 'server';
                        this.getWxImage(result.wx);
                    }
                    if (this.codeType === 'wx') {
                        this.initWxLogin();
                    }

                    this.wayFlag = result.skip;
                    this.wayType = 'wechat';
                    this.lastText = result.phone
                        ? '短信两步验证'
                        : '您还未绑定手机，请验证绑定';
                } catch (error) {
                    let {last_time, day_limit, freeze_day, form_url} = error.data || {};
                    if (error.errcode === 1210) {
                        last_time = moment(last_time).format('YYYY年MM月DD日');
                        this.$modal.alert({
                            title: '定时更新登录密码',
                            hasHTML: true,
                            isHideClose: true,
                            btnText: [ '更新登录密码' ],
                            text: `
                       <div class="tips-update-pwd">
                        <p style="margin-top: 0">尊敬的用户，您好：</p>
                        <p style="line-height: 25px">根据<a target="_blank" style="color: #2196F3 ; text-decoration: underline" href="http://www.gov.cn/xinwen/2016-11/07/content_5129723.htm" >《中华人民共和国网络安全法（中华人民共和国主席令（第五十三号））》</a>和<a target="_blank" style="color: #2196F3 ;text-decoration: underline"  href="http://c.gb688.cn/bzgk/gb/showGb?type=online&hcno=BAFB47E8874764186BDB7865E8344DAF">《信息安全技术网络安全等级保护基本要求（标准号：GB/T 22239-2019）》</a>等法律法规对信息系统身份鉴别的安全要求，规定${ window.__APP__CONFIG.pt_name }的所有用户每${ day_limit }天至少更新一次登录密码。</p>
                        <p style="margin-top: 0">您上次更新登录密码的时间为${ last_time }，请点击“更新登录密码”完成修改。</p>
                       </div>
                    `,
                            okCallback: () => {
                                this.$store.commit('targetEmail', this.loginUser.email);
                                this.$router.push('/update');
                            },
                        });
                        return;
                    } else if (error.errcode === 1216) {
                        this.$modal.alert({
                            title: '定时更新登录密码',
                            hasHTML: true,
                            isHideClose: true,
                            btnText: [ '更新登录密码' ],
                            text: `
                       <div class="tips-update-pwd">
                        <p style="margin-top: 0">尊敬的用户，您好：</p>
                        <p style="line-height: 25px">根据<a target="_blank" style="color: #2196F3 ; text-decoration: underline" href="http://www.gov.cn/xinwen/2016-11/07/content_5129723.htm" >《中华人民共和国网络安全法（中华人民共和国主席令（第五十三号））》</a>和<a target="_blank" style="color: #2196F3 ;text-decoration: underline"  href="http://c.gb688.cn/bzgk/gb/showGb?type=online&hcno=BAFB47E8874764186BDB7865E8344DAF">《信息安全技术网络安全等级保护基本要求（标准号：GB/T 22239-2019）》</a>等法律法规对信息系统身份鉴别的安全要求，规定广东省政府网站集约化平台的所有用户须定期更新登录密码。</p>
                       </div>
                    `,
                            okCallback: () => {
                                this.$store.commit('targetEmail', this.loginUser.email);
                                this.$router.push('/update');
                            },
                        });
                        return;
                    } else if (error.errcode === 1217) {
                        this.$modal.alert({
                            title: '修改登录密码',
                            hasHTML: true,
                            isHideClose: true,
                            btnText: [ '修改登录密码' ],
                            text: `
                       <div class="tips-update-pwd">
                        <p style="margin-top: 0">尊敬的用户，您好：</p>
                        <p style="line-height: 25px">为了您的账号信息安全，首次登录需要修改密码。</p>
                        <p style="line-height: 25px">请您点击“修改登录密码”完成密码修改，谢谢！</p>
                       </div>
                    `,
                            okCallback: () => {
                                this.$store.commit('targetEmail', this.loginUser.email);
                                this.$router.push('/update');
                            },
                        });
                        return;
                    } else if (error.errcode === 1242) {
                        this.$modal.alert({
                            title: '提示',
                            hasHTML: true,
                            text: ` <p style="line-height: 25px">您的账号由于超 ${ freeze_day } 天未登录，已失效，请${ form_url ? `填写<a target="_blank" style="color: #2196F3 ; text-decoration: underline" href="${ form_url }" >《解冻申请》</a>或` : '' }联系管理员。</p>`,
                        });
                        return;
                    }
                    this.$alias.error(`登录失败：${ error.errmessage }`);
                } finally {
                    this.loading = false;
                    this.loadCaptcha();
                }
            },
            async getWxImage (wx) {
                this.formUrl = this.$config.apiUrl.wxSubcribeLogin;
                try {
                    //3.10oldCode
                    // const result = await this.$api(this.$config.apiUrl.wxSubcribeUrl, {
                    //     action: wx ? 'logining_check' : 'logining_bind'
                    // });
                    //3.10newCode
                    const result = await this.$api(this.$config.apiUrl.wxSubcribeUrl, {
                        action: 'logining_bind',
                    });
                    this.codeImageUrl = result.url;
                    this.platformText = `“${ result.wx_app_name }”官方服务号`;
                    if (result.subscribe) {
                        this.scanCodeText = '请使用微信扫描二维码验证';
                        this.platformText = `“${ window.__APP__CONFIG.pt_name }”`;
                    }
                    this.sceneVerifyTimer && clearInterval(this.sceneVerifyTimer);
                    this.startSceneVerifyTimer();
                } catch (error) {
                    this.$alias.error(`获取服务号二维码图片失败：${ error.errmessage }`);
                }
            },
            startSceneVerifyTimer () {
                this.sceneVerifyTimer = setInterval(async () => {
                    try {
                        await this.$api(this.$config.apiUrl.wxSubcribeCheck);
                        this.$nextTick(() => {
                            this.$refs.loginForm.submit();
                        });
                        clearInterval(this.sceneVerifyTimer);
                    } catch (e) {
                        if (e.errcode === 1240) {
                            this.sceneVerifyTimer && clearInterval(this.sceneVerifyTimer);
                            this.getWxImage();
                        } else if (e.errcode !== 1241) {
                            this.$alias.error(`扫码出错：${ e.errmessage }`);
                        }
                    }
                }, 5000);
            },
            goForget () {
                this.$router.push({
                    path: 'forget',
                });
            },
            initWxLogin (api = '/wx/login', state) {
                api = `${ this.$config.getRootUrl() }${ api }`;
                if (this.appId) {
                    api += `?app=${ this.appId }`;
                    if (this.redirectUri) {
                        api = `${ api }&redirect_uri=${ window.encodeURIComponent(
                            this.redirectUri
                        ) }`;
                    }
                }
                return new window.WxLogin({
                    id: 'qr-container',
                    appid: this.$store.state.appUrls.wx_appid,
                    scope: 'snsapi_login',
                    redirect_uri: window.encodeURIComponent(api),
                    state: state || this.state,
                    style: '',
                    href: 'https://cloud.gd.gov.cn/static/wx/loginbox.css',
                });
            },
            loadCaptcha () {
                this.refreshCaptcha();
            },
            refreshCaptcha (type) {
                if (type === 'sms') {
                    this.smsImgCaptchaImg = `${
                        this.$config.apiUrl.captcha
                    }?_r=${ Math.random() }`;
                    return;
                }
                this.captchaImg = `${ this.$config.apiUrl.captcha }?_r=${ Math.random() }`;
            },
            async getOAuthAppInfo (app) {
                try {
                    const result = await this.$api(this.$config.apiUrl.oauthAppInfo, {
                        app,
                    });
                    return result.name;
                } catch (e) {
                    console.log(e);
                    this.$alias.error(e.errmessage);
                }
            },
            gotoRegister () {
                window.location.href = this.$config.webUrl.registerPage;
            },
            gotoUseOtherWay (type) {
                this.wayType = type;
                const temp = this.lastText;
                this.lastText = this.panelText;
                this.panelText = temp;
                setTimeout(() => {
                    this.refreshCaptcha('sms');
                });
            },
            async loginWithSms () {
                if (this.isPending) {
                    return;
                }
                if (this.checkSms()) {
                    return;
                }
                this.$refs.loginFormSms.submit();
                // try {
                //     this.isPending = true;
                //     // const params = {
                //     //     phone: this.loginUser.phone,
                //     //     code: this.loginUser.captcha
                //     // };
                //     // if (this.appId) {
                //     //     params.app = this.appId;
                //     //     if (this.redirectUri) {
                //     //         params.redirect_uri = `${window.encodeURIComponent(this.redirectUri)}`;
                //     //     }
                //     // }
                //     // await this.$api(this.$config.apiUrl.loginWithSms, params);
                //     // window.location.href = '/';
                // } catch (e) {
                //     this.isPending = false;
                //     this.$alias.error(`短信验证失败：${e.errmessage}`);
                // }
            },
            checkSms () {
                if (this.checkPhone()) {
                    return true;
                }
                if (!this.imgCode) {
                    this.$modal.alert({
                        text: '请输入图形验证码',
                        okCallback: () => {
                            this.$refs.imgCode.focus();
                        },
                    });
                    return true;
                }
                if (!this.loginUser.captcha) {
                    this.$modal.alert({
                        text: '请输入手机验证码',
                        okCallback: () => {
                            this.$refs.phoneCaptcha.focus();
                        },
                    });
                    return true;
                }
            },
            checkPhone () {
                const {phone} = this.loginUser;
                if (!this.$util.validate.mobile(phone)) {
                    const text = phone ? '请输入正确格式的手机号码' : '请输入验证手机号码';
                    this.$modal.alert({
                        text: text,
                        okCallback: () => {
                            this.$refs.phone.focus();
                        },
                    });
                    return true;
                }
            },
            async sendSmsCode () {
                if (!this.imgCode) {
                    this.$modal.alert({
                        text: '请输入图形验证码',
                        okCallback: () => {
                            this.$refs.imgCode.focus();
                        },
                    });
                    return;
                }
                if (this.checkPhone() || this.btnText !== '获取验证码') {
                    return;
                }
                try {
                    await this.$api(this.$config.apiUrl.sendPhoneCode, {
                        ...this.loginUser,
                        code: this.imgCode,
                    });
                    this.$alias.ok('验证码发送成功');
                    this.btnText = '60s';
                    const timer = setInterval(() => {
                        let text = parseInt(this.btnText);
                        if (text > 1) {
                            text -= 1;
                            text = `${ text }s`;
                        } else {
                            text = '获取验证码';
                            window.clearInterval(timer);
                        }
                        this.btnText = text;
                    }, 1000);
                } catch (e) {
                    this.$alias.error(`验证码发送失败：${ e.errmessage }`);
                    this.refreshCaptcha('sms');
                }
            },
        },
        async mounted () {
            const appId = (this.appId = this.$route.query.appid || '');
            this.state = this.$route.query.state || '';
            this.redirectUri = this.$route.query.redirect_uri;
            if (appId) {
                this.oauthAppInfo = await this.getOAuthAppInfo(appId);
            }
            this.error_type = this.$route.query.error_type;
            if (this.error_type && this.$config.errorText[this.error_type]) {
                this.wayFlag =
                    !this.error_type.includes('_wx_') && !this.error_type.includes('_sms_');
                if (this.error_type.includes('_sms_')) {
                    this.gotoUseOtherWay('sms');
                    this.$nextTick(() => {
                        this.loginUser.phone = this.$route.query.phone;
                    });
                    // 5.6
                    const _this = this;
                    this.$api(
                        this.$config.apiUrl.hasBind, {}, {
                            method: 'get'
                        }
                    ).then(result => {
                        _this.codeType = 'wx';
                        if (_this.$store.state.appUrls.wx_oauth === '3' && !result.wx) {
                            _this.scanCodeText = '请使用微信扫描二维码验证';
                            _this.codeType = 'server';
                            _this.getWxImage(result.wx);
                        }
                        if (_this.codeType === 'wx') {
                            _this.initWxLogin();
                        }
                    });
                }
                if (this.error_type.includes('_wx_')) {
                    this.initWxLogin();
                }
                this.$alias.error(this.$config.errorText[this.error_type]);
            } else if (window.location.href.includes('1800')) {
                //    多设备登录错误提示
                const query = this.$route.query;
                await this.$router.replace({
                    path: '/',
                    query: {
                        ...query,
                        errcode: undefined
                    }
                });
                this.$modal.alert({
                    text: `当前帐号在其他设备登录，请重新登录后再试。`
                });
            }
            this.loadCaptcha();
            this.initLoginUser();
            setTimeout(() => {
                this.computeHeight();
            });
        },
        computed: {
            btnStyle () {
                const {appConfig} = this.$store.state;
                console.log(appConfig);
                return {
                    backgroundColor: appConfig.pt_color ? '#11a1f8' : '#f44336',
                };
            },
            iptDisabled () {
                return this.$store.state.maskShown.isShow;
            },
        },
        components: {CheckBox, NormalLabel},
    };
</script>
<template>
    <div class="login-box">
        <div class="login-way">
            <div class="way" v-if="wayFlag" :class="[wayFlag ? 'selected' : '']">
                账号登录
            </div>
            <div class="way" v-else :class="[wayFlag ? '' : 'selected']">
                <normal-label
                    class="icon-btn"
                    icon="&#xe698;"
                    @onIconClick="selectWay(true)"
                    marginRight="0.7"
                >
                </normal-label>
                <span>
                    {{ panelText }}
                </span>
            </div>
        </div>
        <transition-group
            name="fade"
            tag="div"
            class="auto-heigth"
            :style="{ height: initedHeight }"
        >
            <form
                ref="loginForm"
                method="post"
                :action="formUrl"
                :key="1"
                class="way-box"
                v-show="wayFlag"
                @keyup.enter="login"
            >
                <input type="hidden" name="token" :value="token"/>
                <input type="hidden" name="_token" :value="csrf_token"/>
                <input type="hidden" name="app" :value="appId"/>
                <input type="hidden" name="state" :value="state"/>
                <input type="hidden" name="redirect_uri" :value="redirectUri"/>
                <div class="way-a-box">
                    <div class="input-group">
                        <span class="input-group-addon">登录邮箱</span>
                        <input
                            autocomplete="off"
                            type="text"
                            :disabled="iptDisabled"
                            placeholder="请输入登录邮箱"
                            ref="email"
                            v-model="loginUser.email"
                        />
                    </div>
                    <div class="input-group">
                        <span class="input-group-addon">登录密码</span>
                        <input
                            autocomplete="off"
                            type="password"
                            :disabled="iptDisabled"
                            placeholder="请输入登录密码"
                            ref="pwd"
                            v-model="pwd"
                        />
                    </div>
                    <div class="input-group">
                        <span class="input-group-addon">验证码</span>
                        <input
                            autocomplete="off"
                            class="captcha-input"
                            type="text"
                            :disabled="iptDisabled"
                            placeholder="验证码"
                            ref="captcha"
                            v-model="code"
                        />
                        <div
                            class="captcha-view"
                            ref="captcha_view"
                            @click="refreshCaptcha"
                        >
                            <img :src="captchaImg" alt="" v-if="captchaImg"/>
                        </div>
                    </div>
                    <div class="input-group" v-show="oauthAppInfo">
            <span class="input-group-addon login-tips" id="login-tips"
            >登录后将前往：{{ oauthAppInfo }}</span
            >
                    </div>
                </div>
                <div class="remember-forget">
                    <!--<check-box-->
                    <!--:checked="checkPwd"-->
                    <!--@check="rememberPwd($event)"-->
                    <!--text="记住密码"-->
                    <!--&gt;</check-box>-->
                    <normal-label
                        style="cursor: pointer"
                        text="忘记密码？"
                        float="right"
                        @click.native="goForget"
                    >
                    </normal-label>
                </div>
                <div class="btn-group">
                    <div :style="btnStyle" class="btn" @click="login">登录</div>
                </div>
                <div class="register" v-if="!hideRegister">
                    <span>还没有账号？</span>
                    <span class="link" @click="gotoRegister">马上注册</span>
                </div>
            </form>
            <div :key="2" class="way-box" v-show="!wayFlag">
                <div v-show="wayType === 'wechat'">
                    <div class="qr-frame">
                        <div
                            class="qr-container"
                            id="qr-container"
                            v-show="codeType === 'wx'"
                        ></div>
                        <div class="qr-container" v-show="codeType === 'server'">
                            <img :src="codeImageUrl" v-if="codeImageUrl" alt=""/>
                        </div>
                    </div>
                    <div class="wx-code-tips">
                        <p>{{ scanCodeText }}</p>
                        <p>{{ platformText }}</p>
                    </div>
                    <!--          <div class="register" v-if="!hideRegister">-->
                    <!--            <span>无法扫码？</span>-->
                    <!--            <span class="link" @click="gotoUseOtherWay('sms')"-->
                    <!--              >短信两步验证</span-->
                    <!--            >-->
                    <!--          </div>-->
                </div>
                <form
                    ref="loginFormSms"
                    method="post"
                    :action="$config.apiUrl.loginWithSms"
                    v-if="wayType === 'sms'"
                    @keyup.enter="loginWithSms"
                >
                    <input type="hidden" name="_token" :value="csrf_token"/>
                    <input type="hidden" name="app" :value="appId"/>
                    <input type="hidden" name="state" :value="state"/>
                    <input type="hidden" name="redirect_uri" :value="redirectUri"/>
                    <div class="way-a-box way-sms">
                        <div class="input-group">
                            <span class="input-group-addon">验证手机</span>
                            <input
                                autocomplete="off"
                                type="text"
                                :disabled="iptDisabled"
                                placeholder="请输入验证手机"
                                name="phone"
                                ref="phone"
                                v-model="loginUser.phone"
                            />
                        </div>
                        <div class="input-group">
                            <span class="input-group-addon">图形验证码</span>
                            <input
                                autocomplete="off"
                                class="captcha-input"
                                type="text"
                                :disabled="iptDisabled"
                                placeholder="图形验证码"
                                ref="imgCode"
                                v-model="imgCode"
                            />
                            <div
                                class="captcha-view"
                                ref="captcha_view"
                                @click="refreshCaptcha('sms')"
                            >
                                <img :src="smsImgCaptchaImg" alt="" v-if="smsImgCaptchaImg"/>
                            </div>
                        </div>
                        <div class="input-group">
                            <span class="input-group-addon">短信验证码</span>
                            <input
                                autocomplete="off"
                                class="captcha-input"
                                type="text"
                                name="code"
                                :disabled="iptDisabled"
                                placeholder="短信验证码"
                                ref="phoneCaptcha"
                                v-model="loginUser.captcha"
                            />
                            <div class="captcha-view" @click="sendSmsCode">
                                {{ btnText }}
                            </div>
                        </div>
                    </div>
                    <div class="btn-group">
                        <div :style="btnStyle" class="btn" @click="loginWithSms">登录</div>
                    </div>
                    <div class="register" v-if="!hideRegister">
                        <span>无法接收验证码？</span>
                        <span class="link" @click="gotoUseOtherWay('wechat')"
                        >微信两步验证</span
                        >
                    </div>
                </form>
            </div>
            <div v-if="showTipsBeforeScan" class="bottom-tips" :key="3">
                <span>&#xe7f9;</span>
                <span>&nbsp;&nbsp;登录即打卡</span>
            </div>
        </transition-group>
    </div>
</template>

<style lang="less" scoped>
    @import "../../assets/less/var.less";

    .bottom-tips{
        height: 58px;
        border-radius: 5px;
        position: absolute;
        bottom: 0;
        left: 0;
        display: flex;
        font-family: cmsicon;
        font-size: 18px;
        align-items: center;
        justify-content: center;
        right: 0;
        background-color: #fae1ac;
        color: #B78652;
    }

    .login-box {
        width: 380px;
        box-sizing: border-box;
        min-height: 460px;
        height: auto;
        background-color: #fff;
        border-radius: 5px;
        padding-top: 60px;
        position: relative;

        .way-box {
            position: absolute;
            left: 0;
            top: 100px;

            .wx-code-tips {
                text-align: center;
                padding: 0;
                color: #333;
                font-size: 13px;

                p {
                    margin: 0;
                    line-height: 20px;
                }
            }
        }

        .auto-heigth {
            transition: all ease-in 0.2s;
            height: auto;
        }

        .icon-btn {
            font-size: 26px;
            margin: 3px 0;
        }

        .login-way {
            width: 100%;
            height: 40px;
            position: relative;
            margin-bottom: 5px;

            .col-split {
                position: absolute;
                left: 50%;
                height: 20px;
                top: 10px;
                width: 1px;
                background-color: #e6e6e6;
            }

            > .way {
                cursor: pointer;
                color: #999999;
                font-size: 18px;
                width: 100%;
                height: 100%;
                //line-height: 40px;
                float: left;
                text-align: left;
                padding-left: 40px;
                padding-right: 40px;
                box-sizing: border-box;
                display: flex;
                align-items: center;
                justify-content: flex-start;

                > * {
                    float: none !important;
                }

                > span {
                    flex: 1;
                }

                &.selected {
                    color: #333333;
                    font-weight: 700;
                }
            }
        }

        .way-a-box {
            &.way-sms {
                height: 240px;
                box-sizing: border-box;
                padding-top: 20px;

                .input-group .captcha-view {
                    background-color: #fbfbfb;
                    font-size: 13px;
                    text-align: center;
                    line-height: 38px;
                    color: #333;
                    cursor: pointer;
                }
            }

            .input-group {
                position: relative;
                display: table;
                border-collapse: separate;
                width: 100%;
                height: 40px;
                padding: 0 40px;
                box-sizing: border-box;
                margin-top: 20px;

                & > .input-group-addon {
                    box-sizing: border-box;
                    width: 100px;
                    font-size: 14px;
                    color: #999999;
                    text-align: center;
                    background-color: #fbfbfb;
                    border: 1px solid #e6e6e6;
                    border-radius: 5px;
                    display: table-cell;
                    border-right: 0;
                    border-top-right-radius: 0;
                    border-bottom-right-radius: 0;
                    height: 30px;
                    vertical-align: middle;
                }

                .login-tips {
                    color: #e64340;
                    border-right: 1px solid #e6e6e6;
                    border-radius: 5px;
                }

                & > input {
                    display: table-cell;
                    box-sizing: border-box;
                    width: 200px;
                    height: 40px;
                    padding: 0 12px;
                    font-size: 14px;
                    line-height: 1.42857143;
                    color: #555;
                    background-color: #fff;
                    background-image: none;
                    border: 1px solid #e6e6e6;
                    border-radius: 5px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;
                    outline: none;

                    &.captcha-input {
                        width: 120px;
                        border-top-right-radius: 0;
                        border-bottom-right-radius: 0;
                    }
                }

                .captcha-view {
                    position: absolute;
                    right: 40px;
                    top: 0;
                    width: 79px;
                    height: 38px;
                    background-color: #e6e6e6;
                    border: 1px solid #e6e6e6;
                    border-left: none;
                    border-radius: 5px;
                    border-top-left-radius: 0;
                    border-bottom-left-radius: 0;

                    img {
                        width: 79px;
                        border-radius: 5px;
                        border-top-left-radius: 0;
                        border-bottom-left-radius: 0;
                        height: 38px;
                    }
                }
            }
        }

        .remember-forget {
            height: 60px;
            width: 100%;
            box-sizing: border-box;
            padding: 10px 40px;
            color: #999999 !important;
            font-size: 12px !important;
        }

        .btn-group {
            height: 50px;
            width: 100%;
            box-sizing: border-box;
            padding: 0 40px;

            > .btn {
                width: 100%;
                height: 50px;
                line-height: 50px;
                text-align: center;
                color: #fff;
                border-radius: 5px;
                cursor: pointer;
            }
        }

        .register {
            height: 50px;
            width: 100%;
            box-sizing: border-box;
            line-height: 40px;
            text-align: center;
            font-size: 14px;
            color: #999999;
            margin-top: 25px;

            .link {
                text-decoration: none;
                color: @blue400;
                cursor: pointer;
            }
        }

        .qrcode-row {
            height: 240px;
            width: 100%;
            padding: 20px 90px;
            box-sizing: border-box;

            > .qrcode {
                width: 200px;
                height: 200px;
                background-color: #999999;

                > canvas {
                    width: 100%;
                    height: 100%;
                }
            }
        }

        .qr-frame {
            width: 380px;
            height: auto;
            margin: 0;
            clear: both;
            position: relative;

            > .qr-container {
                width: 320px;
                height: 200px;
                clear: both;
                margin: 35px auto 15px auto;
                overflow: hidden;
                text-align: center;

                img {
                    width: 200px;
                    height: 200px;
                    margin: 0 auto;
                }
            }
        }
    }

    .modal {
        .qr-frame {
            > .qr-container {
                margin: 0 auto;
            }
        }
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.2s;
    }

    .fade-enter,
    .fade-leave-active {
        opacity: 0;
    }
</style>
